import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const treasurerRoutes: Routes = [
  {
    path: 'tesorero',
    loadComponent: () =>
      import('./treasurer.component').then((c) => c.TreasurerComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'crear-editar-portafolio',
    loadComponent: () =>
      import(
        './pages/create-update-treasure/create-update-treasure.component'
      ).then((c) => c.CreateUpdateTreasureComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'detalle-portafolio',
    loadComponent: () =>
      import('./pages/portfolio-detail/portfolio-detail.component').then(
        (c) => c.PortfolioDetailComponent
      ),
    canActivate: [AuthGuard],
  },
];
